import { AfterViewInit, ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit, TemplateRef, ViewChild, signal } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, AbstractControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api/api.service';
import { TabControlService } from 'src/app/services/tab-control.service';
import { ValidationService } from 'src/app/services/validators/validation.service';
import { NotificationService } from 'src/app/services/notification.service';

import { environment } from 'src/environments/environment';
import * as Constants from "src/app/constants/constants";
import { formatDate } from 'src/app/util/Helper';
import { createIDsValidatorEstate } from 'src/app/services/validators/custom.validators';
import { ExpansionPanel } from 'src/app/components/section/section.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-step3-beneficiary',
  templateUrl: './step3-beneficiary.component.html',
  styleUrls: ['./step3-beneficiary.component.scss']
})
export class Step3BeneficiaryComponent implements OnInit, AfterViewInit, OnDestroy {

  checkerPath: string = `${environment.hRef}assets/fi_check.png`;

  title: string = 'Add Beneficiaries.';
  subtitle: string = 'Add one or more beneficiaries below, then assign shares to each beneficiary.';

  benTypeLabel: string = 'Select Beneficiary Type';
  benTypeHint: string = 'Beneficiary type';

  purposeLabel: string = 'Purpose of Trust';
  purposeHint: string = 'Select purpose of trust';
  purposeSubtext: string = 'Select all applicable purposes for this beneficiary';

  otherPurposeLabel: string = 'Other Purpose';
  otherPurposeHint: string = 'Please specify other purpose';

  titleLabel: string = 'Title';
  titleHint: string = 'Title';
  fNameLabel: string = 'First Name';
  fNameHint : string = 'First name';
  mNameLabel : string = 'Middle Name';
  mNameHint : string = 'Middle name';
  surnameLabel : string = 'Surname';
  surnameHint : string = 'Last name';
  genderLabel: string = 'Gender';
  genderHint: string = 'Select gender';
  phoneLabel : string = 'Primary Phone Number';
  emailLabel : string = 'Email Address';
  emailHint : string = 'Email address';
  dobLabel: string = 'Date of birth';
  dobHint: string = '01/01/1990';
  shareAllocationLabel: string = 'Share Allocation (%)';
  shareAllocationHint: string = 'eg 100';
  shareAllocationSubtext: string = 'The Share allocation for all beneficiaries should total 100%';

  institutionNameLabel: string = 'Name of Institution';
  businessNatureLabel: string = 'Nature of Business';
  orgRegNumLabel: string = 'Organization Registration Number';
  orgAddressLabel: string = 'Organization Physical Address';

  institutionNameHint: string = 'Enter name';
  businessNatureHint: string = 'Enter nature of business';
  orgRegNumHint: string = 'Enter registration Number';
  orgAddressHint: string = 'Enter physical address';

  additionalDetailsText: string = 'Upload Documents';
  // Senior
  idLabel: string = 'ID/Passport Number';
  idHint: string = 'Enter ID or Passport Number';
  kraPinLabel: string = 'KRA PIN';
  kraHint: string = 'Enter KRA PIN';
  idFileLabel: string = 'Upload Copy of ID/Passport';
  // Minor
  birthCertLabel: string = 'Upload Birth Certificate of Child';

  regCertFileLabel: string = 'Upload Registration Certificate';
  kraFileLabel: string = 'Upload KRA PIN';

  addBenText: string = 'Add Another Beneficiary';
  removeBenText: string = 'Remove Beneficiary';

  addText: string = 'Beneficiary details saved';
  updateText: string = 'Beneficiary details updated'
  
  requiredFieldString: string = 'Required field';
  invalidDocString: string = 'Please attach a valid document';

  buttonDisabled: boolean = true;
  addDisabled: boolean = true;

  trustPurposeOptionsEmpty: boolean = true;
  loadingTrustPurposeOptions: boolean = false;


  formErrors: { [key: string]: string } = {
    Category: '',
    TrustPurpose: '',
    OtherPurpose: '',
    Title: '',
    FirstName: '',
    MiddleName: '',
    LastName: '',
    Gender: '',
    Phone: '',
    Email: '',
    DOB: '',
    PercShare: '',
    IDNo: '',
    KraPin: '',
    IDNoImage: '',
    BirthCertImage: '',
    BirthCertNo: '',

    InstitutionName: '',
    BusinessNature: '',
    OrgRegNum: '',
    OrgAddress: '',
    RegCertImage: '',
    KraPinImage: '',
  };

  validationMessages: { [key: string]: {} } = {
    Category: { required: this.requiredFieldString },
    TrustPurpose: { required: this.requiredFieldString },
    OtherPurpose: { required: this.requiredFieldString },
    Title: { required: this.requiredFieldString },
    FirstName: { required: this.requiredFieldString },
    MiddleName: { required: this.requiredFieldString },
    LastName: { required: this.requiredFieldString },
    Gender: { required: this.requiredFieldString },
    Phone: { required: this.requiredFieldString, pattern:'Invalid phone number', exist: 'This number is tied to an existing beneficiary' },
    Email: { required: this.requiredFieldString, email: "Invalid email address" },
    DOB:  { required: this.requiredFieldString },
    PercShare:  { required: this.requiredFieldString, max: `Shares allocated cannot exceed ${this.tabControlService.finalSharesRemaining}%` },
    IDNo:  { required: this.requiredFieldString, pattern:'Invalid ID or Passport number', exist: 'This ID is tied to an existing beneficiary' },
    KraPin: { required: this.requiredFieldString, pattern:'Invalid KRA PIN', exist: 'This PIN is tied to an existing beneficiary' },
    IDNoImage: { required: this.requiredFieldString, invalid: this.invalidDocString },
    BirthCertImage: { required: this.requiredFieldString, invalid: this.invalidDocString },
    BirthCertNo: { required: this.requiredFieldString },

    InstitutionName: { required: this.requiredFieldString },
    BusinessNature: { required: this.requiredFieldString },
    OrgRegNum: { required: this.requiredFieldString },
    OrgAddress: { required: this.requiredFieldString },

    RegCertImage: { required: this.requiredFieldString, invalid: this.invalidDocString },
    KraPinImage: { required: this.requiredFieldString, invalid: this.invalidDocString },
  };

  benForm = this._formBuilder.group({
    beneficiaries: this._formBuilder.array([
      this.createBensFormGroup()
    ]),
  });

  over18: any = '';
  loading: boolean = false;
  loadingText: string = 'Saving Beneficiary';
  currentRecordSaved: boolean = false;

  loadingRemove: boolean = false;
  removeButtonText: string = 'Remove Beneficiary';
  removeContactText: string = 'Remove Contact';
  navigationRequested: boolean = false;
  currentIndex: number = 0;
  shouldInsert: boolean = false;
  areSharesAwarded = signal(false);
  showSharesPopup = signal(false);


  constructor(
    private readonly _formBuilder: FormBuilder,
    private readonly notificationService: NotificationService,
    private readonly tabControlService: TabControlService,
    private readonly validationService: ValidationService,
    private readonly apiService: ApiService,
    private readonly ngZone: NgZone,
    private readonly cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    if (this.beneficiaries && this.beneficiaries.length > 0) {
      if (this.beneficiaries[0].personalDone) {
        const beneficiariesArray = this.benForm.get('beneficiaries') as FormArray;

        // Clear existing beneficiaries
        while (beneficiariesArray.length !== 0) {
          beneficiariesArray.removeAt(0);
        }

        // Add beneficiaries from storage
        this.beneficiaries.forEach((beneficiary: any, index: number) => {
          if (beneficiary.ContactPersons && !Array.isArray(beneficiary.ContactPersons) ) {
            beneficiary.ContactPersons = [beneficiary.ContactPersons];
          }
          beneficiariesArray.push(this.createBensFormGroup(beneficiary, index));
        });

        this.tabControlService.updateStorageObject();
      }  
    }

    if (this.tabControlService.activeTab > 2) {
      this.populateData();
    }
    this.updateValidity();

    this.benForm.statusChanges.subscribe((result) => {this.logErrors();
      this.updateValidity(result);
    });

    // Function to subscribe to valueChanges of the last PercShare control
    const subscribeToLastPercShare = () => {
      if (this.getBens()?.length > 0) {
        this.getBens().controls.forEach((ben, i) => {
          // Get the last control in the FormArray
          const percShare = ben.get('PercShare');

          if (percShare) {
            // Subscribe to valueChanges of the PercShare control
            percShare.valueChanges.subscribe((value) => {
              if (value !== null && value !== '') {
                percShare.patchValue(
                  value
                    .replace(/[^\d]/g, '') // Allow only numbers (remove any non-digit characters)
                    .replace(/^0+/, '') // Remove leading zeros
                    .replace(/[1-9]\d*/, (match: string) =>
                      parseInt(match) > this.tabControlService.managedShares ? 
                      this.tabControlService.managedShares.toString() :
                      // parseInt(match) === 100 && this.getBens().length > 1 ? 98 :
                      match
                    ), // Replace numbers greater than finalSharesRemaining with finalSharesRemaining
                  { emitEvent: false }
                );
              }

              this.updateValidity();
            });
          }
        });
      }
    };

    // Initially subscribe to the last PercShare control
    // subscribeToLastPercShare();

    // Initialize all bensPanels with their FormGroup already created
    this.getBens().controls.forEach((_, i) => {
      if (!this.benPanels[i]) {
        this.benPanels[i] = this.generatePanelsForBeneficiary(i);
      }
    });

    this.setupFormChangeListeners();

    // If new controls are added or removed, re-subscribe to the last PercShare control
    this.benForm.get('beneficiaries')?.valueChanges.subscribe(() => {
      this.logErrors();
      // Unsubscribe from the previous subscription if needed (to avoid memory leaks)
      subscribeToLastPercShare();
    });
    
    this.updateSharesStatus();
  }

  ngAfterViewInit() {
    this.beneficiaries.forEach((_: any, i: number) => {
      this.benPanels[i] = this.generatePanelsForBeneficiary(i);
    });
  }

  ngOnDestroy(): void {
    this.cleanupFormChangeListeners();
  }
  
  getDateDifference(date: string) :boolean {
    const currentDate = new Date();
    const dobDate = new Date(date);
    const ageDifferenceInMilliseconds = currentDate.getTime() - dobDate.getTime();
    const ageDate = new Date(ageDifferenceInMilliseconds);

    // Calculate age based on the year.
    const age = Math.abs(ageDate.getUTCFullYear() - 1970);
    if (age < 18) {
      return false;
    } else {
      return true;
    }
  }

  benPanels: ExpansionPanel[][] = [];
  private formChangesSubscription: Subscription[] = [];

  businessNatureEmpty: boolean = true;

  get TrustPurposeOptions(): any {
    return this.tabControlService.TrustPurposeOptions;
  }
  get beneficiaries(): any {
    return this.tabControlService.beneficiaries;
  }
  get finalRemainingShares() {
    return Number(this.tabControlService.finalSharesRemaining);
  }
  get remainingShares() {
    return this.tabControlService.sharesRemaining;
  }
  get minDate() {
    return this.tabControlService.minDOBDate;
  }
  get maxDate() {
    return this.tabControlService.maxDOBDate;
  }

  get loadingTitles(): boolean {
    return this.tabControlService.loadingTitles;
  }
  get TitleOptions(): any {
    return this.tabControlService.TitleOptions;
  }
  get BeneficiaryOptions():any {
    return this.tabControlService.BeneficiaryOptions;
  }
  get GenderOptions():any {
    return this.tabControlService.GenderOptions;
  }

  get loadingBizNature(): boolean {
    return this.tabControlService.loadingBizNature;
  }
  get BusinessNatureOptions(): any {
    return this.tabControlService.BusinessNatureOptions;
  }

  get region(): any {
    return this.tabControlService.regionType;
  }

  get saveProgress(): ()=> void {
    return this.tabControlService.saveProgress;
  }

  logErrors() {
    this.formErrors = this.validationService.logValidationErrors(
      this.benForm,
      this.formErrors,
      this.validationMessages
    );
  }

  updateValidity(result: any = '') {    
    if (this.benForm.valid) {
      if (this.loading) {
        this.buttonDisabled = true;
      } else {
        this.buttonDisabled = false;
      }
    } else {
      this.buttonDisabled = true;
    }
    
  };
  updateSharesStatus() {
    try {
      let allSharesDone = true;      
      if (!this.beneficiaries || this.beneficiaries.length === 0 || this.beneficiaries[0]?.done === false ) {  
        allSharesDone = false;
      } else {
        for (const beneficiary of this.beneficiaries) {
          if (beneficiary.done && (!beneficiary.PercShare || beneficiary.PercShare === '' || beneficiary.PercShare === '0') ) {
            allSharesDone = false;
            break;
          }
        }
      }
      this.areSharesAwarded.set(allSharesDone);
      console.log('>>> Shares awarded status updated: ', allSharesDone);
    } catch (error) {
      console.warn('Share status will be updated: ', error);
    }
    
  }

  async populateData(): Promise<void> {
    if (this.TrustPurposeOptions.length === 0) {
      await this.getTrustPurposeOptionsList().then(()=> {
        if (this.TrustPurposeOptions.length === 0) this.notificationService.viewToast('error', 'Failed to load some data');
      });
    }
    if (this.TitleOptions.length === 0) {
      this.tabControlService.loadingTitles = true;
      await this.tabControlService.getTitlesList();
      this.tabControlService.loadingTitles = false;
    }
    if (this.BusinessNatureOptions.length === 0) {
      this.tabControlService.loadingBizNature = true;
      await this.tabControlService.getBusinessNatOptionsList();
      this.tabControlService.loadingBizNature = false;
    }
  }

  async getTrustPurposeOptionsList() {
    this.loadingTrustPurposeOptions = true;
    try {
      const response = await this.apiService.getRequest(
        environment.baseUrl + Constants.purposeURL
      );

      if (response.Status === 1) {
        this.tabControlService.TrustPurposeOptions = response.Data;
        this.trustPurposeOptionsEmpty = false;
      } else {
        console.log('>>> Error : ', response.Message);
        this.trustPurposeOptionsEmpty = true;
      }
    } catch(error) {
      console.log('>>> Error !! ', error);
    }
    this.loadingTrustPurposeOptions = false;
  }

  organizeValues(items: any): string {
    try {
      if (typeof items == 'string') {
        return items;
      }
      
      let output: string = items[0];
      for (let i=1; i<items.length; i++) {
        output = output + ', ' +items[i];
      }
      return output;
    } catch (error) {
      console.log('Error : ', error);
      return '';
    }
  }

  arrayContainsValue(arr: string | null | undefined, value: string) {
    return arr && arr.includes(value);
  }

  updateIDObject(index: number, object: any): void {
    if (!object) return;
    const bens = this.beneficiaries;
    const latestRecord = bens[index];
    let updatedRecord = {
      ...latestRecord,
      ...{IDNoImage: object}
    };

    Object.assign(bens[index], updatedRecord);
    this.tabControlService.updateRecord(3, bens);
  }
  updateKraObject(index: number, object: any): void {
    if (!object) return;
    const bens = this.beneficiaries;
    const latestRecord = bens[index];
    let updatedRecord = {
      ...latestRecord,
      ...{KraPinImage: object}
    };

    Object.assign(bens[index], updatedRecord);
    this.tabControlService.updateRecord(3, bens);
  }
  updateBirthCertObject(index: number, object: any): void {
    if (!object) return;
    const bens = this.beneficiaries;
    const latestRecord = bens[index];
    let updatedRecord = {
      ...latestRecord,
      ...{BirthCertImage: object}
    };

    Object.assign(bens[index], updatedRecord);
    this.tabControlService.updateRecord(3, bens);
  }
  updateRegCertObject(index: number, object: any): void {
    if (!object) return;
    const bens = this.beneficiaries;
    const latestRecord = bens[index];
    let updatedRecord = {
      ...latestRecord,
      ...{RegCertImage: object}
    };

    Object.assign(bens[index], updatedRecord);
    this.tabControlService.updateRecord(3, bens);
  }

  onBenTypeChange(index: number): void {
    this.ngZone.runOutsideAngular(() => {
      // Batch all form control updates
      setTimeout(() => {
        const formGroup = this.getBensFormGroup(index);
        const beneType = formGroup.get('Category')?.value;

        if (!beneType) return;

        // Disable automatic change detection during updates
        this.ngZone.run(() => {
          if (beneType.toLowerCase() === 'individual') {
            // Batch clear organization controls
            ['InstitutionName', 'BusinessNature', 'OrgRegNum', 'KraPin', 'OrgAddress']
              .forEach(controlName => {
                formGroup.get(controlName)?.clearValidators();
                formGroup.get(controlName)?.setValue('');
              });

            // Batch add individual validators
            ['FirstName', 'LastName', 'DOB']
              .forEach(controlName => {
                this.validationService.addOrRemoveValidator(true, formGroup.get(controlName)!);
            });
            
          } else {
            // Batch clear individual controls
            ['Title', 'FirstName', 'MiddleName', 'LastName', 'DOB', 'Gender',
              'Phone', 'Email'
            ].forEach(controlName => {
              formGroup.get(controlName)?.clearValidators();
              formGroup.get(controlName)?.setValue('');
            });

            // Batch add institution validators
            ['InstitutionName', 'BusinessNature', 'OrgRegNum', 'OrgAddress', 'KraPin']
              .forEach(controlName => {
                this.validationService.addOrRemoveValidator(true, formGroup.get(controlName)!);
                if (controlName === 'KraPin') {
                  this.validationService.addOrRemove3Validators(
                    true,
                    this.getBensFormGroup(index).get('KraPin')!,
                    [Validators.required,
                      Validators.pattern(/^[AP]\d{9}[A-Z]$/),
                      createIDsValidatorEstate('PIN', this.getBens(), this.beneficiaries)
                    ]
                  );
                }
            });
          }

          // Force panel regeneration after category change
          this.benPanels[index] = this.generatePanelsForBeneficiary(index);
        });
      });
    });
  }

  createBensFormGroup(beneficiary?: any, index?: number): FormGroup {
    let form: FormGroup;

    if (beneficiary) {
      const currentIndex = index ?? this.beneficiaries.length-1;
      const contact = beneficiary.ContactPersons && beneficiary.ContactPersons[0] ? beneficiary.ContactPersons[0] : null;

      let trustPurpose = [];

      if (beneficiary.TrustPurpose) {
        trustPurpose = Array.isArray(beneficiary.TrustPurpose) ? beneficiary.TrustPurpose : [beneficiary.TrustPurpose];
      }

      form = this._formBuilder.group({
        Category: [`${beneficiary.Category || this.BeneficiaryOptions[0]}`, Validators.required],
        TrustPurpose: [trustPurpose, Validators.required],
        OtherPurpose: [`${beneficiary.OtherPurpose || ''}`],
        Title: [`${beneficiary.Title || ''}`],
        FirstName: [`${beneficiary.FirstName || ''}`],
        MiddleName: [`${beneficiary.MiddleName || ''}`],
        LastName: [`${beneficiary.LastName || ''}`],
        Gender: [`${beneficiary.Gender || ''}`],
        Phone: [`${beneficiary.Phone || ''}`],
        Email: [`${beneficiary.Email || ''}`, Validators.email],
        DOB: [beneficiary.DOB ? new Date(beneficiary.DOB) : null],
        PercShare: [beneficiary.PercShare || '0'],
        IDNo: [`${beneficiary.IDNo || ''}`],
        KraPin: [`${beneficiary.KraPin || ''}`],
        IDNoImage: [''],
        BirthCertNo: [`${beneficiary.BirthCertNo || ''}`],
        BirthCertImage: [''],
        ContactPersons:  this._formBuilder.array([
          this.createContactsGroup(contact, null, currentIndex)
        ]),
        InstitutionName: [`${beneficiary.InstitutionName || ''}`],
        BusinessNature: [`${beneficiary.BusinessNature || ''}`],
        OrgRegNum: [`${beneficiary.OrgRegNum || ''}`],
        OrgAddress: [`${beneficiary.OrgAddress || ''}`],
  
        RegCertImage: [''],
        KraPinImage: ['']
      }) as FormGroup & { [key: string]: AbstractControl };

      if (beneficiary.ContactPersons && beneficiary.ContactPersons.length > 1) {
        const contactArray = form.get('ContactPersons') as FormArray;

        beneficiary.ContactPersons.forEach((contact: any, index: number) => {
          if (index > 0) contactArray.push(this.createContactsGroup(contact, contactArray, currentIndex));
        });
      }

      if (beneficiary.IDNoImage) {
        if (beneficiary.IDNoImage.stringValue && beneficiary.IDNoImage.stringValue.length > 0) {
          form.get('IDNoImage')?.setValue(beneficiary.IDNoImage.stringValue);
        }
      }
      if (beneficiary.KraPinImage) {
        if (beneficiary.KraPinImage.stringValue && beneficiary.KraPinImage.stringValue.length > 0) {
          form.get('KraPinImage')?.setValue(beneficiary.KraPinImage.stringValue);
        }
      }
      if (beneficiary.BirthCertImage) {
        if (beneficiary.BirthCertImage.stringValue && beneficiary.BirthCertImage.stringValue.length > 0) {
          form.get('BirthCertImage')?.setValue(beneficiary.BirthCertImage.stringValue);
        }  
      }
      if (beneficiary.RegCertImage) {
        if (beneficiary.RegCertImage.stringValue && beneficiary.RegCertImage.stringValue.length > 0) {
          form.get('RegCertImage')?.setValue(beneficiary.RegCertImage.stringValue);
        }
      }

      if (!beneficiary.Category || beneficiary.Category === 'Individual') {
        form.get('FirstName')?.addValidators(Validators.required);
        form.get('LastName')?.addValidators(Validators.required);
        form.get('Gender')?.addValidators(Validators.required);
        form.get('DOB')?.addValidators(Validators.required);

        if (beneficiary.contactsDone) {
          if (this.getDateDifference(beneficiary.DOB)) {
            form.get('IDNo')?.addValidators([Validators.required, createIDsValidatorEstate('ID', this.getBens(), this.beneficiaries)]);
            // Validation not required for diaspora
            if (this.region == 1) {
              form.get('KraPin')?.addValidators(
                [Validators.pattern(/^[AP]\d{9}[A-Z]$/), createIDsValidatorEstate('PIN', this.getBens(), this.beneficiaries)]
              );
            } else {
              form.get('KraPin')?.addValidators(
                [Validators.required, Validators.pattern(/^[AP]\d{9}[A-Z]$/), createIDsValidatorEstate('PIN', this.getBens(), this.beneficiaries)]
              );
            }

            form.get('IDNoImage')?.addValidators(Validators.required);
            if (this.region == 0) form.get('KraPinImage')?.addValidators(Validators.required);

          } else {
            form.get('BirthCertImage')?.addValidators(Validators.required);
            form.get('BirthCertNo')?.addValidators(Validators.required);
          }
          // disable DOB input from getting updated on the current formgroup
          form.get('DOB')?.disable();
        }

      } else {
        form.get('InstitutionName')?.addValidators(Validators.required);
        form.get('BusinessNature')?.addValidators(Validators.required);
        form.get('OrgRegNum')?.addValidators(Validators.required);
        form.get('OrgAddress')?.addValidators(Validators.required);
        // Only require KRA PIN for Kenyan entities, not diaspora
        if (this.region == 0)
          form.get('KraPin')?.addValidators(Validators.required);

        if (beneficiary.contactsDone) {
          form.get('RegCertImage')?.addValidators(Validators.required);
          form.get('KraPinImage')?.addValidators(Validators.required);
        }
      }

    } else {
      if (
        this.beneficiaries && this.beneficiaries.length > 0 &&
        !(this.beneficiaries[0].personalDone && this.beneficiaries[0].personalDone == true)
      ) {
          this.tabControlService.refreshRecord(3);
      }
      
      let currentBens = this.tabControlService.beneficiaries;
      let currentRecord = {personalDone: false, contactsDone: false, done: false};

      if (
        (this.benForm && this.getBens().length > 0) ||
        this.beneficiaries &&
        (this.beneficiaries.length > 0 &&
          !(this.beneficiaries[0].personalDone && this.beneficiaries[0].personalDone == true) ) ||
        this.beneficiaries.length == 0
      ) {
        currentBens.push(currentRecord);
        this.tabControlService.updateRecord(3, currentBens);
      }
      
      form = this._formBuilder.group({
        Category: [this.BeneficiaryOptions[0], Validators.required],
        TrustPurpose: [[], Validators.required],
        OtherPurpose: [''],
        Title: [''],
        FirstName: ['', Validators.required],
        MiddleName: [''],
        LastName: ['', Validators.required],
        Gender: ['', Validators.required],
        Phone: [''],
        Email: ['', Validators.email],
        DOB: ['', Validators.required],
        PercShare: ['0'],
        ContactPersons: this._formBuilder.array([
          this.createContactsGroup()]
        ),
        IDNo: [''],
        KraPin: [''],
        IDNoImage: [''],

        BirthCertNo: [''],
        BirthCertImage: [''],
  
        InstitutionName: [''],
        BusinessNature: [''],
        OrgRegNum: [''],
        OrgAddress: [''],
  
        RegCertImage: [''],
        KraPinImage: ['']
      }) as FormGroup & { [key: string]: AbstractControl };
    }

    if (this.benForm && this.getBens().length > 0) {
      this.validationService.addOrRemoveOneValidator(
        true,
        form.get('Phone')!,
        createIDsValidatorEstate('TEL', this.getBens(), this.beneficiaries)
      );

      this.validationService.addOrRemoveSpecificValidators(
        true,
        form.get('Email')!,
        [ Validators.email,
          createIDsValidatorEstate('EMAIL', this.getBens(), this.beneficiaries)
        ]
      );
    }

    form.get('TrustPurpose')?.valueChanges.subscribe((data) => {
      if (this.arrayContainsValue(data, 'Other'))
        this.validationService.addOrRemoveValidator(true, form.get('OtherPurpose')!);
      else
        this.validationService.addOrRemoveValidator(false, form.get('OtherPurpose')!);
    });

    return form;
  };

  createContactsGroup(contact?: any, formArray?: FormArray | null, benIndex?: number): FormGroup {
    let contactForm: FormGroup;
    const Index = benIndex ?? this.beneficiaries.length-1;

    if (contact) {
      contactForm = this._formBuilder.group({
        Title: [`${contact.Title || ''}`],
        FirstName: [`${contact.FirstName || ''}`],
        MiddleName: [`${contact.MiddleName || ''}`],
        LastName: [`${contact.LastName || ''}`],
        Phone: [`${contact.Phone || ''}`],
        Email: [`${contact.Email || ''}`]
      });

    } else {
      contactForm = this._formBuilder.group({
        Title: [''],
        FirstName: [''],
        MiddleName: [''],
        LastName: [''],
        Phone: [''],
        Email: ['']
      });
    }

    if (this.beneficiaries[Index]?.personalDone && this.beneficiaries[Index]?.Category === this.BeneficiaryOptions[1]) {
      contactForm.get('FirstName')?.addValidators(Validators.required);
      contactForm.get('LastName')?.addValidators(Validators.required);

      if (this.benForm) {
        if (formArray) {
          this.validationService.addOrRemoveSpecificValidators(
            true,
            contactForm.get('Phone')!,
            [Validators.required, createIDsValidatorEstate('TEL', formArray, this.beneficiaries[Index].ContactPersons)]
          );
          this.validationService.addOrRemove3Validators(
            true,
            contactForm.get('Email')!,
            [Validators.required, Validators.email, createIDsValidatorEstate('EMAIL', formArray, this.beneficiaries[Index].ContactPersons)]
          );
        } else {
          contactForm.get('Phone')?.addValidators(Validators.required);
          contactForm.get('Email')?.addValidators([Validators.required, Validators.email]);
        }
      }
    }
    
    return contactForm;
  };

  async addNewBen() {
    const fields = this.benForm.get('beneficiaries') as FormArray;
    const newFormGroup = this.createBensFormGroup();
    fields.push(newFormGroup);
    
    // Wait for view to update
    await new Promise(resolve => setTimeout(resolve));
    
    const newIndex = fields.length - 1;
    this.benPanels[newIndex] = this.generatePanelsForBeneficiary(newIndex);
    
    // Set up listeners after panels are generated
    this.setupFormChangeListenersForIndex(newIndex);
    this.updateSharesStatus();
  }
  async addNewContact(index:number) {
    const fields = this.getContacts(index);
    let currentContacts = fields.value;

    if (currentContacts.length > 0) {
      const currentBens = this.beneficiaries;
      let latestRecord = currentBens[index];

      if (latestRecord.ContactPersons?.length > 0) {
        currentContacts = currentContacts.map((contact: any) => {
          let matchingContact = latestRecord.ContactPersons.find(
            (ogContact: any) => (ogContact && contact.Phone === ogContact.Phone)
          );
          return matchingContact && matchingContact.ContactID
            ? {...contact, ContactID: Number(matchingContact.ContactID)}
            : contact;
        });
      }
      let updatedRecord = {
        ...latestRecord,
        ...{ContactPersons: currentContacts}
      };
      Object.assign(currentBens[index], updatedRecord);
      this.tabControlService.updateRecord(3, currentBens);
    }
    fields.push(this.createContactsGroup(null, fields, index));
    this.getBensFormGroup(index).setControl('ContactPersons', fields);
  }
  
  async removeBen(i:number) {
    this.currentIndex = i;
    const fields = this.benForm.get('beneficiaries') as FormArray;
    let currentBens = this.tabControlService.beneficiaries;

    if (currentBens[i] && currentBens[i].BeneficiaryID) {
      this.removeButtonText = 'Removing Beneficiary';
      this.loadingRemove = true;

      try {
        if (this.tabControlService.TrustID !== null) {
          const result = await this.tabControlService.removeRecord(
            'Beneficiaries',
            currentBens[i].BeneficiaryID,
            Number.parseInt(this.tabControlService.TrustID),
            'Beneficiary'
          );
  
          if (result === 1) {
            this.notificationService.viewToast('success', 'Beneficiary removed successfully');

            fields.removeAt(i);
  
            if (currentBens[i].IdURL) 
              this.tabControlService.removeFromDocSummary('ID', 'Beneficiary', currentBens[i].BeneficiaryID);
            if (currentBens[i].KraURL)
              this.tabControlService.removeFromDocSummary('PIN', 'Beneficiary', currentBens[i].BeneficiaryID);
            if (currentBens[i].BirthCertURL)
              this.tabControlService.removeFromDocSummary('BirthCert', 'Beneficiary', currentBens[i].BeneficiaryID);
            if (currentBens[i].RegCertURL)
              this.tabControlService.removeFromDocSummary('RegCert', 'Beneficiary', currentBens[i].BeneficiaryID);

            currentBens.splice(i, 1);;
              this.tabControlService.updateRecord(3, currentBens);
          } else {
            this.notificationService.viewToast('error', 'Error removing record');
          }
        } else {
          console.log('Relevant IDs not found');
        }
      } catch (error) {
        console.log(':: Error !! ', error);
      }
      this.removeButtonText = this.removeBenText;
      this.loadingRemove = false;
    } else {
      if (currentBens[i]) {
        fields.removeAt(i);
        // Remove ben at index
        currentBens.splice(i, 1);;
        this.tabControlService.updateRecord(3, currentBens);
      } else {
        fields.removeAt(i);
      }
    }

    if (this.tabControlService.beneficiaries[this.tabControlService.beneficiaries.length-1].done) {
      this.currentRecordSaved = true;
    }
    this.updateValidity();
    this.updateSharesStatus();
  }
  async removeContact(i:number, j: number) {
    const fields = this.getContacts(i);
    fields.removeAt(j);
    this.updateValidity();
    
    let currentContacts = fields.value;

    if (currentContacts.length > 0) {
      const currentBens = this.beneficiaries;
      let latestRecord = currentBens[i];

      if (latestRecord.ContactPersons?.length > 0) {
        currentContacts = currentContacts.map((contact: any) => {
          let matchingContact = latestRecord.ContactPersons.find(
            (ogContact: any) => (ogContact && contact.Phone === ogContact.Phone)
          );
          return matchingContact?.ContactID
            ? {...contact, ContactID: Number(matchingContact.ContactID)}
            : contact;
        });
      }
      let updatedRecord = {
        ...latestRecord,
        ...{ContactPersons: currentContacts}
      };
      Object.assign(currentBens[i], updatedRecord);
      this.tabControlService.updateRecord(3, currentBens);
    }
  }

  getBens() : FormArray {  
    return this.benForm.get("beneficiaries") as FormArray;
  }
  getContacts(index: number) : FormArray {
    return this.getBens().at(index).get('ContactPersons') as FormArray;  
  }
  getBensFormGroup(index: number): FormGroup {
    return this.getBens().at(index) as FormGroup;
  }
  getContactsFormGroup(index: number, innerdex: number): FormGroup {
    return this.getContacts(index).at(innerdex) as FormGroup;
  }
  isFormArray(control: AbstractControl | null): control is FormArray {
    return control instanceof FormArray;
  }

  async saveBeneficiary(index: number, record: FormGroup, editingShares: boolean = false): Promise<void> {
    if (this.beneficiaries[index].personalDone || this.beneficiaries[index].contactsDone) this.loadingText = 'Updating Beneficiary';
    else this.loadingText = 'Saving Beneficiary';

    let tsMessage = this.addText;

    this.loading = true;
    this.notificationService.isLoading(true);
    
    try {
      let temp = record.getRawValue();

      const originalPurpose = temp.TrustPurpose;
      let originalContacts;
      let purpose = this.organizeValues(originalPurpose);

      if (temp.OtherPurpose && temp.OtherPurpose.length > 1) {
        purpose = purpose + ': ' +temp.OtherPurpose;
      }
      
      temp.TrustPurpose = purpose;

      // Ensure ContactPersons is always an array
      if (temp.ContactPersons) {
        if (!Array.isArray(temp.ContactPersons)) temp.ContactPersons = [temp.ContactPersons];
        
        if (this.beneficiaries[index].ContactPersons?.length > 0) {
          temp.ContactPersons = temp.ContactPersons.map((contact: any) => {
            const matchingContact = this.beneficiaries[index].ContactPersons.find(
              (ogContact: any) => (ogContact?.ContactID && contact.Phone === ogContact.Phone)
            );
            return matchingContact 
              ? {...contact, ContactID: Number(matchingContact.ContactID)}
              : contact;
          });
        }

        originalContacts = temp.ContactPersons;
        
      } else {
        temp.ContactPersons = [];
      }

      if (record.getRawValue().Category.toLowerCase() === 'individual') {
        temp.DOB = formatDate(record.getRawValue().DOB);
        temp.ContactPersons = [];
      }

      let data = {...temp, ...{TrustID: this.tabControlService.TrustID?.toString()}};

      let currentBens = this.tabControlService.beneficiaries;
      
      if (currentBens[index].IDNoImage) {
        data.IDNoImage = currentBens[index].IDNoImage;
      } else {
        data.IDNoImage = {name: '', stringValue: ''};
      }
      if (currentBens[index].KraPinImage) {
        data.KraPinImage = currentBens[index].KraPinImage;
      } else {
        data.KraPinImage = {name: '', stringValue: ''};
      }

      if (currentBens[index].RegCertImage) {
        data.RegCertImage = currentBens[index].RegCertImage;
      } else {
        data.RegCertImage = {name: '', stringValue: ''};
      }
      if (currentBens[index].BirthCertImage) {
        data.BirthCertImage = currentBens[index].BirthCertImage;
      } else {
        data.BirthCertImage = {name: '', stringValue: ''};
      }
      
      if (currentBens[index].BeneficiaryID) {
        data = {...data, ...{BeneficiaryID: currentBens[index].BeneficiaryID}};
      }

      const response = await this.apiService.postRequest(
        environment.baseUrl + Constants.saveBenURL, data);
      if (response.Status === 1) {
        let currentBens = this.beneficiaries;

        const latestRecord = currentBens[index];
        const recordValueWithoutImages = Object.fromEntries(
          Object.entries(record.getRawValue()).filter(([key]) => !key.includes('Image'))
        );
        const updatedRecord = {
          ...latestRecord,
          ...recordValueWithoutImages,
          ...{BeneficiaryID: response.BeneficiaryID}
        };
        Object.assign(currentBens[index], updatedRecord);

        this.tabControlService.updateRecord(3, currentBens);
        currentBens = this.beneficiaries;
        let currentRecord = currentBens[index];

        if (currentRecord.contactsDone) {
          tsMessage = this.updateText;
          
          if (record.getRawValue().Category.toLowerCase() === 'individual') {
            currentRecord.ContactPersons = originalContacts;    
          } else {
            if (response.ContactPersons?.length > 0) {
              currentRecord.ContactPersons = currentRecord.ContactPersons.map((contact: any) => {
                const matchingContact = response.ContactPersons.find(
                  (ogContact: any) => contact.Phone === ogContact.Phone
                );
                return matchingContact 
                  ? {...contact, ContactID: Number(matchingContact.ContactID)}
                  : contact;
              });
            }
          }

          if (data.IDNoImage && data.IDNoImage.stringValue.length > 5 && response.IdURL) {
            currentRecord = {...currentRecord, ...{IDURL: response.IdURL, SavedID: currentRecord.IDNoImage}};
            this.tabControlService.removeFromDocSummary('ID', 'Beneficiary', currentRecord.BeneficiaryID);
            this.tabControlService.updateDocSummary(response.IdURL);
          }
          if (data.KraPinImage && data.KraPinImage.stringValue.length > 5 && response.KraURL) {
            currentRecord = {...currentRecord, ...{KraURL: response.KraURL, SavedPIN: currentRecord.KraPinImage}};
            this.tabControlService.removeFromDocSummary('PIN', 'Beneficiary', currentRecord.BeneficiaryID);
            this.tabControlService.updateDocSummary(response.KraURL);
          }
          if (data.BirthCertImage && data.BirthCertImage.stringValue.length > 5 && response.BirthCertURL) {
            currentRecord = {...currentRecord, ...{BirthCertURL: response.BirthCertURL, SavedBirthCert: currentRecord.BirthCertImage}};
            this.tabControlService.removeFromDocSummary('BirthCert', 'Beneficiary', currentRecord.BeneficiaryID);
            this.tabControlService.updateDocSummary(response.BirthCertURL);
          }
          if (data.RegCertImage && data.RegCertImage.stringValue.length > 5 && response.RegCertURL) {
            currentRecord = {...currentRecord, ...{RegCertURL: response.RegCertURL, SavedRegCert: currentRecord.RegCertImage}};
            this.tabControlService.removeFromDocSummary('RegCert', 'Beneficiary', currentRecord.BeneficiaryID);
            this.tabControlService.updateDocSummary(response.RegCertURL);
          }
          currentRecord.done = true;
          Object.assign(currentBens[index], currentRecord);

          this.tabControlService.updateRecord(3, currentBens);

          this.currentRecordSaved = true;
          
          // update shares tracker
          this.tabControlService.updateFinalRemainingShares(this.tabControlService.sharesRemaining);

        } else {
          if (record.getRawValue().Category.toLowerCase() === 'individual') {
            currentRecord.personalDone = true;
            currentRecord.contactsDone = true;
            Object.assign(currentBens[index], currentRecord);

            this.tabControlService.updateRecord(3, currentBens);
            // disable DOB input from getting updated on the current formgroup
            this.getBensFormGroup(index).get('DOB')?.disable();

            if (this.getDateDifference(record.getRawValue().DOB)) {
              this.validationService.addOrRemoveValidator(
                true,
                this.getBensFormGroup(index).get('IDNoImage')!);

              this.validationService.addOrRemoveSpecificValidators(
                true,
                this.getBensFormGroup(index).get('IDNo')!,
                [Validators.required, createIDsValidatorEstate('ID', this.getBens(), this.beneficiaries)]
              );

              if (this.region == 1) {
                this.validationService.addOrRemoveSpecificValidators(
                  true,
                  this.getBensFormGroup(index).get('KraPin')!,
                  [Validators.pattern(/^[AP]\d{9}[A-Z]$/), createIDsValidatorEstate('PIN', this.getBens(), this.beneficiaries)]
                );
              } else {
                this.validationService.addOrRemove3Validators(
                  true,
                  this.getBensFormGroup(index).get('KraPin')!,
                  [Validators.required, Validators.pattern(/^[AP]\d{9}[A-Z]$/), createIDsValidatorEstate('PIN', this.getBens(), this.beneficiaries)]
                );
              }

            } else {
              this.validationService.addOrRemoveValidator(
                true,
                this.getBensFormGroup(index).get('BirthCertImage')!);
              this.validationService.addOrRemoveValidator(
                true,
                this.getBensFormGroup(index).get('BirthCertNo')!);
              
            }

            if (this.beneficiaries.length <= 1) this.tabControlService.updateTrustProgress('Beneficiaries');

          } else {
            if (currentRecord.personalDone) {
              if (response.ContactPersons?.length > 0) {
                currentRecord.ContactPersons = currentRecord.ContactPersons.map((contact: any) => {
                  const matchingContact = response.ContactPersons.find(
                    (ogContact: any) => contact.Phone === ogContact.Phone
                  );
                  return matchingContact 
                    ? {...contact, ContactID: Number(matchingContact.ContactID)}
                    : contact;
                });
              }
              currentRecord.contactsDone = true;

              Object.assign(currentBens[index], currentRecord);
              this.tabControlService.updateRecord(3, currentBens);

              this.validationService.addOrRemoveValidator(true,
                this.getBensFormGroup(index).get('RegCertImage')!);

              this.validationService.addOrRemoveValidator(true,
                this.getBensFormGroup(index).get('KraPinImage')!);

              setTimeout(() => {
                this.cdr.detectChanges();
              });  

            } else {
              currentRecord.personalDone = true;

              if (record.getRawValue().Category === this.BeneficiaryOptions[1]) { // institutions setup for contact persons
                try {
                  this.validationService.addOrRemoveValidator(
                    true,
                    this.getContactsFormGroup(index, 0 ).get('FirstName')!
                  );
                  this.validationService.addOrRemoveValidator(
                    true,
                    this.getContactsFormGroup(index, 0 ).get('LastName')!
                  );
                  
                  this.validationService.addOrRemoveOneValidator(
                    true,
                    this.getContactsFormGroup(index, 0 ).get('Phone')!,
                    Validators.required
                  );
        
                  this.validationService.addOrRemoveSpecificValidators(
                    true,
                    this.getContactsFormGroup(index, 0 ).get('Email')!,
                    [
                      Validators.required,
                      Validators.email]
                  );
                } catch (error) { }
              }

              Object.assign(currentBens[index], currentRecord);
              this.tabControlService.updateRecord(3, currentBens);

              if (this.beneficiaries.length <= 1) this.tabControlService.updateTrustProgress('Beneficiaries');
            }
          }
          this.updateValidity();
        }
        if (!environment.production) console.log('>> New Beneficiaries !! \n', this.tabControlService.beneficiaries);
        
        this.notificationService.viewToast('success', tsMessage);
        this.updateDoneStatus(index, currentRecord)

      } else {
        this.notificationService.viewToast('error', response.Message);
      }
    } catch (error) {
      console.error(':: Error !! ', error);
      this.notificationService.viewToast('error', 'An unexpected error occurred');
    }
    this.notificationService.isLoading(false);
    this.loading = false;
  }

  async updateProgress(): Promise<void> {
    const bens = this.benForm.get('beneficiaries') as FormArray;
    await this.saveBeneficiary(bens.length - 1, this.getBensFormGroup(bens.length - 1));
    this.saveProgress();
  }

  awardShares(index: number): void {
    this.saveBeneficiary(index, this.getBensFormGroup(index), true);
  }


  // ==============  EXPANSION SECTION   =================
  @ViewChild('beneficiaryInfo') beneficiaryInfo!: TemplateRef<any>;
  @ViewChild('contactInfo') contactInfo!: TemplateRef<any>;
  @ViewChild('uploadDocs') uploadDocs!: TemplateRef<any>;

  generatePanelsForBeneficiary = (i: number): ExpansionPanel[] => {
    // Fallback if templates not ready
    if (!this.beneficiaryInfo || !this.contactInfo || !this.uploadDocs || !this.beneficiaries[i]) {
      return [];
    }

    const isIndividual = this.getBensFormGroup(i).get('Category')?.value === this.BeneficiaryOptions[0];
    
    if (isIndividual) {
      return [
        {
          title: 'Beneficiary Information',
          contentTemplate: this.beneficiaryInfo,
          context: { index: i },
          expanded: !(this.beneficiaries[i].personalDone),
          done: (this.beneficiaries[i].personalDone)
        },
        {
          title: 'Upload Documents',
          contentTemplate: this.uploadDocs,
          context: { index: i },
          disabled: !(this.beneficiaries[i].contactsDone),
          expanded: (this.beneficiaries[i].contactsDone && !this.beneficiaries[i].done),
          done: (this.beneficiaries[i].done)
        }
      ];
    } else {
      return [
        {
          title: 'Beneficiary Information',
          contentTemplate: this.beneficiaryInfo,
          context: { index: i },
          expanded: !(this.beneficiaries[i].personalDone),
          done: (this.beneficiaries[i].personalDone)
        },
        {
          title: 'Contact Person Information',
          contentTemplate: this.contactInfo,
          context: { index: i },
          disabled: !(this.beneficiaries[i].personalDone),
          expanded: (this.beneficiaries[i].personalDone && !this.beneficiaries[i].contactsDone),
          done: (this.beneficiaries[i].contactsDone)
        },
        {
          title: 'Upload Documents',
          contentTemplate: this.uploadDocs,
          context: { index: i },
          disabled: !(this.beneficiaries[i].contactsDone),
          expanded: (this.beneficiaries[i].contactsDone && !this.beneficiaries[i].done),
          done: (this.beneficiaries[i].done)
        }
      ];
    }
  }

  updateDoneStatus(i: number, value: any) {
    // Ensure panels array exists
    this.benPanels = this.benPanels || [];
    
    // Initialize if missing or invalid
    if (!this.benPanels[i] || this.benPanels[i].length < 2 ) {
      this.benPanels[i] = this.generatePanelsForBeneficiary(i);
    }

    const panels = this.benPanels[i];
    const isIndividual = this.getBensFormGroup(i).get('Category')?.value === this.BeneficiaryOptions[0];
    
    // Update panel states while preserving context
    if (panels[0]) {
      panels[0].done = value.personalDone;
      // Preserve existing context or initialize if missing
      panels[0].context = panels[0].context || { index: i };
      panels[0].expanded = !value.personalDone;
    }
    
    if (panels[1]) {
      panels[1].done = isIndividual ? value.done : value.contactsDone;
      panels[1].context = panels[1].context || { index: i }; // Preserve context
      panels[1].disabled = !value.personalDone;
      panels[1].expanded = value.personalDone && (isIndividual ? !value.done : !value.contactsDone);
    }
    
    if (panels[2]) {
      panels[2].done = value.done;
      panels[2].context = panels[2].context || { index: i }; // Preserve context
      panels[2].disabled = !value.contactsDone;
      panels[2].expanded = value.contactsDone && !value.done;
    }

    setTimeout(()=> {
      try {
        if (value.BeneficiaryID && !value.done && i == this.beneficiaries.length-1) {
          this.notificationService.viewToast(
            'info',
            `Beneficiary ${isIndividual ? value.FirstName+' '+value.LastName : value.InstitutionName}`,
            `Please continue to ${
              value.contactsDone ? panels[isIndividual ? 1 : 2].title :
              'add ' +panels[1].title 
            }`
          );
        }
        
      } catch (error) {}
      
    })
  }

  async updateRecord(index: number) {
    await this.saveBeneficiary(index, this.getBensFormGroup(index));
  }

  private setupFormChangeListeners() {
    this.cleanupFormChangeListeners();
    
    this.getBens().controls.forEach((control) => {
      // General form changes
      const subscription = (control as FormGroup).valueChanges.subscribe(() => {
        this.cdr.markForCheck();
      });
      this.formChangesSubscription.push(subscription);
    });
  }
  private setupFormChangeListenersForIndex(index: number) {
    const control = this.getBens().at(index) as FormGroup;

    // Clean up existing subscription if any
    const existingSub = this.formChangesSubscription[index];
    if (existingSub) {
      existingSub.unsubscribe();
    }

    // General form changes
    const subscription = (control as FormGroup).valueChanges.subscribe(() => {
      this.cdr.markForCheck();
    });

    if (subscription) this.formChangesSubscription[index] = subscription;
  }
  private cleanupFormChangeListeners() {
    this.formChangesSubscription.forEach(sub => sub.unsubscribe());
    this.formChangesSubscription = [];
  }

  private readonly loggedErrors = new Set<string>();

  confirmFormMatchesRecord(index: number): boolean {
    try {
      const ben = this.beneficiaries[index];
      const formGroup = this.getBensFormGroup(index);
      
      if (!ben?.done || !formGroup) {
        return true;
      }

      // Compare multi-select Trust Purpose array
      const formPurposes: any[] = formGroup.get('TrustPurpose')?.value || [];
      const recordPurposes: any[] = ben.TrustPurpose || [];

      // Normalize form beneficiary IDs to sorted strings
      const formPurposeIds = formPurposes
        .map(item => (item)?.toString())
        .filter(Boolean)
        .sort();

      // Normalize record beneficiary IDs to sorted strings
      const recordPurposeIds = recordPurposes
        .map(item => (item)?.toString())
        .filter(Boolean)
        .sort();

      const purposesMatch =
        formPurposeIds.length === recordPurposeIds.length &&
        formPurposeIds.every((id, idx) => id === recordPurposeIds[idx]);

      const isIndividual = ben.Category === this.BeneficiaryOptions[0];

      // Compare all relevant fields
      if (isIndividual) {
        const dobValue = this.getBensFormGroup(index).get('DOB')?.value;
        const isAdult = this.getDateDifference(dobValue);

        const fieldsToCompare = isAdult ? [
          'Title', 'FirstName', 'MiddleName', 'LastName', 'Phone', 'Email', 
          'Gender','OtherPurpose', 'IDNo', 'KraPin'
        ] : [
          'Title', 'FirstName', 'MiddleName', 'LastName', 'Phone', 'Email', 
          'Gender', 'OtherPurpose', 'BirthCertNo'
        ];

        const basicFieldsMatch = fieldsToCompare.every(field => {
          const benValue = ben[field];
          const formValue = formGroup.get(field)?.value;
          const valuesMatch = (formValue || '') === (benValue || '');
          
          // If either value is empty, consider this field as matching
          return valuesMatch;
        });

        let filesMatch = true;

        if (isAdult) {
          if (ben?.KraPinImage?.name) {
            filesMatch =
              ben.IDNoImage.name === ben.SavedID.name &&
              ben.KraPinImage.name === ben.SavedPIN.name;
          } else {
            filesMatch = ben.IDNoImage.name === ben.SavedID.name;
          }
        } else {
          filesMatch =
            ben.BirthCertImage.name === ben.SavedBirthCert.name;
        }

        return basicFieldsMatch && filesMatch && purposesMatch;

      } else {
        const fieldsToCompare = [
          'InstitutionName', 'BusinessNature', 'OrgRegNum', 'OrgAddress', 
          'KraPin', 'OtherPurpose'
        ];

        const basicFieldsMatch = fieldsToCompare.every(field => {
          const benValue = ben[field];
          const formValue = formGroup.get(field)?.value;
          const valuesMatch = (formValue || '') === (benValue || '');

          // If either value is empty, consider this field as matching
          return valuesMatch;
        });

        let filesMatch = true;

        filesMatch =
          ben.RegCertImage.name === ben.SavedRegCert.name &&
          ben.KraPinImage.name === ben.SavedPIN.name;

        return basicFieldsMatch && filesMatch && purposesMatch;
      }
    } catch (error: any) {
      const errorKey = `error-${index}-${error.message}`;
      if (!this.loggedErrors.has(errorKey)) {
        console.error('Error in confirmFormMatchesRecord:', error);
        this.loggedErrors.add(errorKey);
      }
      return false;
    }
  }

  // +++++++++++++++++++++++++++++++++++++++++++++++++++++

  submitForm(): void {
    if (this.beneficiaries[this.beneficiaries.length-1].done === true) {
      if (this.areSharesAwarded()) {
        this.navigateFunction();
        
      } else {
        this.notificationService.viewToast(
          'info',
          'Please assign all shares before proceeding',
          `Maximum allocation cannot exceed ${this.remainingShares} shares`);
        
          this.showSharesPopup.set(true);
      }
      
    } else {
      const bens = this.benForm.get('beneficiaries') as FormArray;
      this.saveBeneficiary(bens.length - 1, this.getBensFormGroup(bens.length - 1));
    }
  }

  async navigateFunction(): Promise<void> {
    await this.tabControlService.changeTab(4);
    this.tabControlService.page3Done = true;
  }
}
